
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPlaceholderDeviceOffF as ObiPlaceholderDeviceOffFElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-placeholder-device-off-f.js';
 
 
 

 
 export const ObiPlaceholderDeviceOffF = createComponent({
   react: React,
   tagName: 'obi-placeholder-device-off-f',
   elementClass: ObiPlaceholderDeviceOffFElement,
   events: {
     
   }
  });
 
 